import { SESClient, SendEmailCommand } from "@aws-sdk/client-ses";

// AWS SES Configuration
const sesClient = new SESClient({
  region: import.meta.env.VITE_AWS_REGION,
  credentials: {
    accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID,
    secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY,
  },
});

/**
 * Sends an email using AWS SES.
 * @param {string} subject - The subject of the email.
 * @param {string} body - The body content of the email.
 * @param {string[]} [toEmails] - Optional list of recipient emails. Defaults to the configured email.
 */
export const sendEmail = async (
  subject: string,
  body: string,
  toEmails: string[] = [import.meta.env.VITE_AWS_SES_TO_EMAIL]
) => {
  try {
    const params = {
      Destination: {
        ToAddresses: toEmails,
      },
      Message: {
        Body: {
          Text: {
            Data: body,
          },
        },
        Subject: {
          Data: subject,
        },
      },
      Source: import.meta.env.VITE_AWS_SES_FROM_EMAIL,
      ReplyToAddresses: [import.meta.env.VITE_AWS_SES_REPLY_TO_EMAIL],
    };

    const command = new SendEmailCommand(params);
    const response = await sesClient.send(command);
    console.log("Email sent successfully:", response);
    return response;
  } catch (error) {
    console.error("Error sending email:", error);
    throw error;
  }
};
